export default __webpack_public_path__ + "static/media/icon_infrastructure.6e7229f6.svg";